module.exports = __webpack_public_path__ + "static/img/no1.0602ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/no1.png
// module id = aMaa
// module chunks = 1